export const WMarkerConfig = {
    dropsonde: {
        //投落送
        max: 200,
        popup: true,
    },
    flight: {
        //飛行軌跡
        max: 400, //同檔案最大風標數(預設500)
        show_wm_dir: true, //是否顯示風標(預設為true)
        scale: 1, //風標大小(預設為1)
        zoom_ctrl: {
            jump: {
                //根據zoom顯示的跳點數, zoom值須由小至大
                'zoom-normal': 10, //基礎跳點數, 10=每10個顯示1個
                'zoom-9': 5, //地圖zoom值>=9的跳點數, 5=每5個顯示1個
                'zoom-11': 1 //地圖zoom值>=11的跳點數, 1=不跳點(全顯示)
            }
        },
        popup: [
            {
                name: "溫度(°C)",
                column: [
                    "TEMP"
                ],
                unit: "°C"
            },
            {
                name: "高度(ft)",
                column: [
                    "HEIGHT"
                ],
                unit: "ft"
            },
            {
                name: "風向(°)",
                column: [
                    "WDIR"
                ],
                unit: "°"
            },
            {
                name: "風速(kts)",
                column: [
                    "WSPD"
                ],
                unit: "kts"
            }
        ],
    },
    auto: {
        //自動站
        max: 550,
        zoom_ctrl: {
            jump: {
                'zoom-normal': 2,
                'zoom-9': 1
            },
            show: {
                name: 10,
                params: 11
            }
        },
        scale: 0.75,
        // from webmap json
        // popup: [{
        //         column: ['CITY', 'TOWN'],
        //         name: '縣市'
        //     },
        // ]
    },
    station: {
        //地面氣象站
        max: 200,
        zoom_ctrl: {
            show: {
                name: 9,
                params: 9
            }
        },
        scale: 0.75,
    },
    gauge: {
        //雨量站
        max: 1150,
        show_wm_dir: false,
        zoom_ctrl: {
            show: {
                name: 11,
                params: 10
            }
        },
        // collision_enable: false,
        color_map: [
            //(*)色階對照
            [192, 192, 192, 1],
            [153, 255, 255, 5],
            [0, 204, 255, 10],
            [0, 153, 255, 12],
            [0, 102, 255, 15],
            [0, 139, 0, 20],
            [0, 255, 0, 25],
            [255, 255, 0, 30],
            [255, 204, 0, 50],
            [255, 153, 0, 70],
            [255, 0, 0, 90],
            [204, 0, 0, 110],
            [153, 0, 153, 130],
            [204, 0, 204, 150],
            [255, 0, 255, 200],
            [255, 204, 255, 300],
        ],
    }
};
